// extracted by mini-css-extract-plugin
export var cardIcon = "_7j-4";
export var checkboxCard = "_7j-0";
export var checkboxCardSelected = "_7j-3";
export var disabled = "_7j-1";
export var outerBorder = "_7j-2";
export var spacerMedium = "_7j-7";
export var spacerSmall = "_7j-6";
export var spacerXsmall = "_7j-5";